module.exports = __webpack_public_path__ + "static/media/checkCardOrderStatusIcon.fcc75c6c.svg";